import axios from "axios";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllFAQs = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: "GET_FAQS_REQUEST" });
            const { data } = await axios.get(
                `${BASE_URL}/faq/all`,
                config
            );
            if (data.statusCode === 200) {
                dispatch({ type: "GET_FAQS_SUCCESS", payload: data });
            } else {
                dispatch({ type: "GET_FAQS_FAILURE", payload: data });
            }
        } catch (error) {
            dispatch({ type: "GET_FAQS_FAILURE", payload: error.response });
            return { success: false }
        }
    };
};
export const addFAQ=(faq)=>{
    return async (dispatch) => {
        try {
            dispatch({ type: "ADD_FAQ_REQUEST" });
            const { data } = await axios.post(
                `${BASE_URL}/faq/add`,
                faq,
                config
            );
            if (data.statusCode === 200) {
                dispatch({ type: "ADD_FAQ_SUCCESS", payload: data });
            } else {
                dispatch({ type: "ADD_FAQ_FAILURE", payload: data });
            }
        } catch (error) {
            dispatch({ type: "GET_FAQS_FAILURE", payload: error.response });
            return { success: false }
        }
    };
}
export const updateFAQ = (faq) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "UPDATE_FAQ_REQUEST" });

            const { data } = await axios.put(
                `${BASE_URL}/faq/update`,
               faq,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "UPDATE_FAQ_SUCCESS", payload: data });
            } else {
                dispatch({ type: "UPDATE_FAQ_FAILURE", payload: data });
            }
        } catch (error) {
            dispatch({
                type: "UPDATE_FAQ_FAILURE",
                payload: error?.response || error.message,
            });
            return { success: false };
        }
    };
};


